import analytics from "../../../../util/analytics";
import ReactPixel from "react-facebook-pixel/src/index";

export const infoReasons = [
  {
    reason: "We need your contact information to send you your estimate.",
  },
  {
    reason:
      "Our in house roofing experts team will call you and help you throughout your entire roofing project.",
  },
  {
    reason:
      "We will not send your information to any contractors without your permission!",
  },
];

export const formFields = [
  {
    name: "fullName",
    required: true,
    type: "text",
    title: "Full Name",
    placeholder: "John Doe",
  },
  {
    name: "email",
    required: true,
    type: "email",
    title: "Email",
    placeholder: "johndoe@gmail.com",
  },
  {
    name: "phoneNumber",
    required: true,
    type: "number",
    title: "Phone",
    placeholder: "+1 (800) 401-7716",
  },
];

export const sendTrackingRequest = (pathname) => {

  ReactPixel.track("Contact Information Submission");
  return analytics.track("Contact Information Submission");
  // switch (pathname) {
    //   case "/":
    //     ReactPixel.track("Contact Information Submission");
    //     analytics.track("Contact Information Submission");
  //     break;

  //   case "/get-roof-report":
  //     ReactPixel.track("Submission - Used Phone");
  //     analytics.track("Submission - Used Phone");
  //     break;
  //   case "/get-roof-report/":
  //     ReactPixel.track("Submission - Used Phone");
  //     analytics.track("Submission - Used Phone");
  //     break;

  //   case "/generate-report":
  //     ReactPixel.track("Submission - Used Email");
  //     analytics.track("Submission - Used Email");
  //     break;

  //   case "/generate-report/":
  //     ReactPixel.track("Submission - Used Email");
  //     analytics.track("Submission - Used Email");
  //     break;

  //   default:
  //     break;
  // }
};
